import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Typography,
} from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  StyledSelect,
  StyledTextField,
} from "../../customComponents/styled/styledInputs";
import { StyledLoadingButton } from "../../customComponents/styled/styledButtons";
import { StyledPaper } from "../../customComponents/styled/styledPaper";
import { useGetSubSectionQuery } from "../settings/sections/sectionsApiSlice";
import { useUpdateClassroomMutation } from "./classApiSlice";
import toast from "../../../helpers/toast";

const classFormValidation = yup.object({
  name: yup.string().required("Required"),
  description: yup.string(),
});

function UpdateClass({ item }) {
  const { data: subsections } = useGetSubSectionQuery("all");
  const [updateClassroom, { isLoading: updateClassroomLoading }] =
    useUpdateClassroomMutation();

  const classForm = useFormik({
    initialValues: {
      name: item?.name || "",
      description: item?.description || "",
      level: item?.level || "",
      subsection: item?.subsection_id || "",
    },
    enableReinitialize: true,
    validationSchema: classFormValidation,
    onSubmit: async (values) => {
      try {
        const body = {
          id: item.id,
          name: values.name,
          description: values.description,
          level: values.level,
          subsection_id: values.subsection,
        };
        const response = await updateClassroom(body).unwrap();
        if (response.id) {
          toast.success("Classroom updated successfully");
        } else {
          toast.error("Classroom not updated");
        }
      } catch (error) {
        toast.error(error?.message || "Something went wrong");
      }
    },
  });

  return (
    <StyledPaper>
      <Box className="paperHeader">
        <Typography variant="paperHeading">Update Class</Typography>
      </Box>
      <Box className="paperBody">
        <form onSubmit={classForm.handleSubmit}>
          <Grid container columnSpacing={1} rowSpacing={2}>
            <Grid item xs={12} md={6}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">Name of class</Typography>
                <StyledTextField
                  // autoFocus
                  variant="outlined"
                  id="name"
                  name="name"
                  value={classForm.values.name}
                  onChange={classForm.handleChange}
                  error={
                    classForm.touched.name && Boolean(classForm.errors.name)
                  }
                />
                <FormHelperText variant="error">
                  {classForm.touched.name && classForm.errors.name}
                </FormHelperText>
              </FormControl>
            </Grid>
            {/* <Grid item xs={12} md={6}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">
                  Class Description
                </Typography>
                <StyledTextField
                  autoFocus
                  variant="outlined"
                  id="description"
                  name="description"
                  value={classForm.values.description}
                  onChange={classForm.handleChange}
                  error={
                    classForm.touched.description &&
                    Boolean(classForm.errors.description)
                  }
                />
                <FormHelperText variant="error">
                  {classForm.touched.description &&
                    classForm.errors.description}
                </FormHelperText>
              </FormControl>
            </Grid> */}

            <Grid item xs={12} md={6}>
              <FormControl error fullWidth>
                <Typography variant="formSubHeading">Level</Typography>
                <StyledTextField
                  variant="outlined"
                  id="level"
                  name="level"
                  value={classForm.values.level}
                  onChange={classForm.handleChange}
                  error={
                    classForm.touched.level && Boolean(classForm.errors.level)
                  }
                />
                <FormHelperText variant="error">
                  {classForm.touched.level && classForm.errors.level}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <Typography variant="formSubHeading">sub-Section</Typography>
                <StyledSelect
                  displayEmpty
                  id="subsection"
                  name="subsection"
                  value={classForm.values.subsection}
                  onChange={classForm.handleChange}
                  error={
                    classForm.touched.subsection &&
                    Boolean(classForm.errors.subsection)
                  }
                >
                  <MenuItem value="" disabled>
                    <em>select subsection</em>
                  </MenuItem>
                  {subsections?.map((subsection) => (
                    <MenuItem key={subsection.id} value={subsection.id}>
                      {subsection.name}
                    </MenuItem>
                  ))}
                </StyledSelect>
                <FormHelperText variant="error">
                  {classForm.touched.subsection && classForm.errors.subsection}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} textAlign={"right"}>
              <StyledLoadingButton
                loading={updateClassroomLoading}
                type="submit"
              >
                Update
              </StyledLoadingButton>
            </Grid>
          </Grid>
        </form>
      </Box>
    </StyledPaper>
  );
}

export default UpdateClass;
